import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function tagReducer(state = initialState.tags, action) {
	switch (action.type) {
		case types.LOAD_TAGS_SEARCH_DATA:
			return Object.assign({}, state, {
				options: action.data,
			});
		case types.ADD_TAG_SELECTED:
			//only add if the tag was not already selected
			const tagAlreadyExists = state.selectedTags.some((tag) => tag === action.data);
			if (!tagAlreadyExists) {
				return Object.assign({}, state, {
					selectedTags: [...state.selectedTags, action.data],
				});
			}
			return state;
		case types.DELETE_TAG_SELECTED:
			return {
				...state,
				selectedTags: [...state.selectedTags.filter((tag) => tag !== action.data)],
			};
		case types.REMOVE_ALLTAGS_SELECTED:
			return {
				...state,
				selectedTags: [],
			};
		default:
			return state;
	}
}
